/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_PreviewInputs */

const cs_portals_preview = /** @type {(inputs: Portals_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled inzerátu`)
};

const en_portals_preview = /** @type {(inputs: Portals_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview advert`)
};

/**
* | output |
* | --- |
* | "Preview advert" |
*
* @param {Portals_PreviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_preview = /** @type {((inputs?: Portals_PreviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_PreviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_preview(inputs)
	return cs_portals_preview(inputs)
});